import React, { Component } from "react";
import "./index.less";

function App(props){
	const year = new Date().getFullYear();
	const { i18n } = props;
	
    return (
    	<div className="video-footer-wrap">
			<p className="video-copyright">{i18n.copyright1 + year + i18n.copyright2}</p>
		</div>
    )
}


export default App;